import { c } from "react-compiler-runtime";
import { useState, useEffect } from "react";
import { MONACO_THEME_NAME } from "../constants.js";
import { useMonaco } from "../stores/monaco.js";
const SETTINGS_STORAGE_KEY = "graphiql:settings";
const DEFAULTS = {
  theme: "auto",
  density: "comfortable",
  fontSize: "default"
};
function readSettings() {
  if (typeof window === "undefined") {
    return DEFAULTS;
  }
  try {
    const raw = localStorage.getItem(SETTINGS_STORAGE_KEY);
    if (!raw) {
      return DEFAULTS;
    }
    const parsed = JSON.parse(raw);
    return {
      ...DEFAULTS,
      ...parsed
    };
  } catch {
    return DEFAULTS;
  }
}
function writeSettings(settings) {
  try {
    localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings));
  } catch {
  }
}
function resolveTheme(theme) {
  if (theme !== "auto") {
    return theme;
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function useGraphiQLSettings(containerRef) {
  const $ = c(21);
  const [settings, setSettings] = useState(readSettings);
  const monaco = useMonaco(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function setTheme2(theme) {
      setSettings((s) => ({
        ...s,
        theme
      }));
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setTheme = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function setDensity2(density) {
      setSettings((s_0) => ({
        ...s_0,
        density
      }));
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setDensity = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function setFontSize2(fontSize) {
      setSettings((s_1) => ({
        ...s_1,
        fontSize
      }));
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setFontSize = t2;
  let t3;
  if ($[3] !== containerRef || $[4] !== (monaco == null ? void 0 : monaco.editor) || $[5] !== settings) {
    t3 = () => {
      writeSettings(settings);
      const resolvedTheme = resolveTheme(settings.theme);
      const target = (containerRef == null ? void 0 : containerRef.current) ?? document.querySelector(".graphiql-container");
      if (target) {
        target.setAttribute("data-theme", resolvedTheme);
        target.setAttribute("data-density", settings.density);
        target.setAttribute("data-font-size", settings.fontSize);
      }
      monaco == null ? void 0 : monaco.editor.setTheme(MONACO_THEME_NAME[resolvedTheme]);
    };
    $[3] = containerRef;
    $[4] = monaco == null ? void 0 : monaco.editor;
    $[5] = settings;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== containerRef || $[8] !== monaco || $[9] !== settings) {
    t4 = [settings, containerRef, monaco];
    $[7] = containerRef;
    $[8] = monaco;
    $[9] = settings;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== containerRef || $[12] !== (monaco == null ? void 0 : monaco.editor) || $[13] !== settings.theme) {
    t5 = () => {
      if (settings.theme !== "auto") {
        return;
      }
      const mql = window.matchMedia("(prefers-color-scheme: dark)");
      const onSystemThemeChange = function onSystemThemeChange2() {
        const resolvedTheme_0 = resolveTheme("auto");
        const target_0 = (containerRef == null ? void 0 : containerRef.current) ?? document.querySelector(".graphiql-container");
        if (target_0) {
          target_0.setAttribute("data-theme", resolvedTheme_0);
        }
        monaco == null ? void 0 : monaco.editor.setTheme(MONACO_THEME_NAME[resolvedTheme_0]);
      };
      mql.addEventListener("change", onSystemThemeChange);
      return () => {
        mql.removeEventListener("change", onSystemThemeChange);
      };
    };
    $[11] = containerRef;
    $[12] = monaco == null ? void 0 : monaco.editor;
    $[13] = settings.theme;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== containerRef || $[16] !== monaco || $[17] !== settings.theme) {
    t6 = [settings.theme, containerRef, monaco];
    $[15] = containerRef;
    $[16] = monaco;
    $[17] = settings.theme;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  useEffect(t5, t6);
  let t7;
  if ($[19] !== settings) {
    t7 = {
      ...settings,
      setTheme,
      setDensity,
      setFontSize
    };
    $[19] = settings;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function _temp(state) {
  return state.monaco;
}
export {
  SETTINGS_STORAGE_KEY,
  useGraphiQLSettings
};
//# sourceMappingURL=use-graphiql-settings.js.map
